import React from 'react';
import { Container, Row, Navbar, NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';


var style = {
    backgroundColor: "#1D1D1D",
    borderTop: "1px solid #E7E7E7",
    textAlign: "center",
    padding: "2em",
    width: "100%",
    marginTop: "2em"
}

function Footer({ children }) {
    return (
        <div className="footer" id="siteFooter">  
            <div style={style}>
                <div className="d-flex flex-row justify-content-around align-items-center">
                    
                    <Link to="/"><img src="imgs/logo-footer.webp" alt="Temple Law Logo" style={{ maxWidth: "243px" }} /></Link>

                    <div>
                        <p style={{ color: "#F2EEE8", fontSize: "30px", marginBottom: "0" }}>Summer Work Study</p>
                        <p style={{ color: "grey", textAlign: "right", fontSize: "20px" }}>Student Work Log</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer